import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ "deviceForm" ];

  changeDevice(event) {
    this.deviceFormTarget.submit();
  }
}